export const carouselItems = [
  {
    id: 1,
    title: '暑期档热播大片合集',
    description: '汇聚今夏最热门影视作品，苹果视频、豆花视频、菠萝视频同步更新，高清画质畅享不间断观影体验，每日更新多部精彩内容。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20movie%20collage%20with%20film%20reels%20and%20warm%20theater%20lighting%2C%20dark%20cinematic%20background%20with%20golden%20accents%2C%20movie%20poster%20aesthetic%20with%20dramatic%20spotlight%20effects%2C%20professional%20cinema%20photography%20style%20with%20rich%20contrasts%20and%20deep%20shadows%2C%20entertainment%20industry%20vibe&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '热门推荐',
  },
  {
    id: 2,
    title: '经典港片修复重映专题',
    description: '重温黄金年代经典港片，4K修复版高清呈现，红杏视频独家整理，涵盖动作、喜剧、爱情等多种类型，唤起一代人共同记忆。',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20nostalgic%20film%20scene%20with%20vintage%20movie%20posters%20and%20warm%20retro%20lighting%2C%20dark%20theater%20background%20with%20golden%20decorative%20elements%2C%20old%20school%20cinema%20aesthetic%20with%20film%20grain%20texture%2C%20dramatic%20shadow%20play%20and%20rich%20amber%20tones%2C%20nostalgic%20entertainment%20atmosphere&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '经典重温',
  },
  {
    id: 3,
    title: '日韩剧集精选连播',
    description: '青青草视频同步引进最新日韩热门剧集，中文字幕完整版第一时间上线，从都市情感到悬疑推理，满足多元追剧需求。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20and%20Korean%20drama%20series%20elegant%20visual%20collage%20with%20soft%20cinematic%20lighting%20and%20modern%20aesthetic%2C%20dark%20theater%20backdrop%20with%20warm%20accent%20lights%2C%20contemporary%20Asian%20entertainment%20photography%20style%20with%20clean%20composition%2C%20emotional%20storytelling%20atmosphere%20with%20gentle%20contrasts&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '海外剧场',
  },
  {
    id: 4,
    title: '国产精品剧集年度盘点',
    description: '91视频网站年度高分国产剧大盘点，涵盖古装、都市、悬疑等热门类型，豆瓣高分认证，豆花视频和菠萝视频提供多线路播放。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20domestic%20drama%20series%20artistic%20arrangement%20with%20traditional%20and%20modern%20elements%20blending%2C%20dark%20cinematic%20background%20with%20warm%20golden%20highlights%2C%20elegant%20entertainment%20photography%20with%20rich%20cultural%20textures%2C%20professional%20film%20industry%20aesthetic%20with%20dramatic%20lighting%20and%20deep%20shadows&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '年度盘点',
  },
];

export const comments = [
  {
    id: 1,
    name: '影迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20man%20with%20friendly%20expression%2C%20simple%20warm%20gray%20studio%20background%2C%20clean%20minimalist%20headshot%20photography%20with%20soft%20natural%20lighting%2C%20professional%20yet%20approachable%20look&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '用了榴莲视频快一年了，资源更新速度真的快！苹果视频和91视频网站的内容基本都能在这里找到，画质也很清晰，看高清影视首选。',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '追剧达人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20simple%20neutral%20studio%20background%2C%20clean%20headshot%20photography%20with%20soft%20diffused%20lighting%2C%20modern%20casual%20professional%20look&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '豆花视频和菠萝视频的资源整合得太棒了，不用来回切换App，一个站就能看遍全网热播。红杏视频的专题策划也做得很有深度。',
    date: '2026-07-26',
  },
  {
    id: 3,
    name: '深夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20man%20in%20his%20thirties%20with%20thoughtful%20expression%2C%20simple%20warm%20studio%20background%2C%20clean%20minimalist%20headshot%20with%20soft%20lighting%2C%20mature%20professional%20vibe&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '青青草视频的片源质量不错，分类也很清晰。希望后续能加入更多4K内容，大屏幕观看体验会更上一层楼。整体来说很满意。',
    date: '2026-07-25',
  },
  {
    id: 4,
    name: '电影发烧友',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20young%20adult%20with%20enthusiastic%20expression%2C%20simple%20gray%20studio%20background%2C%20clean%20headshot%20photography%20with%20natural%20lighting%2C%20modern%20casual%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '影片推荐算法很精准，每次打开首页都能发现感兴趣的内容。高清影视播放流畅不卡顿，移动端体验也很棒，通勤路上追剧神器。',
    date: '2026-07-24',
  },
  {
    id: 5,
    name: '周末追剧党',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20woman%20with%20relaxed%20expression%2C%20simple%20neutral%20studio%20background%2C%20clean%20headshot%20photography%20with%20soft%20warm%20lighting%2C%20friendly%20approachable%20look&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 5,
    content: '从朋友推荐开始使用，现在已经离不开了。菠萝视频的高清片源加上榴莲视频的聚合能力，视频播放体验真的没话说，推荐给所有爱看剧的朋友。',
    date: '2026-07-22',
  },
];

export const features = [
  {
    id: 1,
    icon: 'ri-movie-2-line',
    title: '海量影视资源',
    description: '聚合苹果视频、91视频网站、豆花视频、菠萝视频等多家平台内容，影视资源丰富全面，一站式满足各类观影需求，每日持续更新。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清画质体验',
    description: '支持多种清晰度选择，从标清到超清随心切换，高清影视观看效果出众，配合智能缓冲技术确保流畅不卡顿的视频播放体验。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    description: '支持桌面端与移动端同步观看，红杏视频、青青草视频等站点内容跨设备无缝衔接，随时随地畅享影视观看的便捷与自由。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '安全稳定可靠',
    description: '采用先进的视频传输加密技术，保障用户观看隐私与数据安全，服务器多节点部署确保高清影视服务高可用性，畅看无忧。',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '《时光之刃》独家预告片',
    category: '动作科幻',
    views: '128.6万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20action%20movie%20scene%20with%20futuristic%20cityscape%20and%20dramatic%20lighting%2C%20dark%20cinematic%20background%20with%20neon%20accents%2C%20film%20poster%20style%20composition%20with%20epic%20scale%20and%20motion%20blur%20effects%2C%20professional%20movie%20photography%20aesthetic&width=640&height=360&seq=media-01&orientation=landscape',
    duration: '02:35',
  },
  {
    id: 2,
    title: '《烟火人间》温情短片',
    category: '剧情文艺',
    views: '95.3万',
    image: 'https://readdy.ai/api/search-image?query=Warm%20emotional%20Chinese%20drama%20film%20scene%20with%20soft%20natural%20lighting%20and%20cozy%20domestic%20setting%2C%20dark%20theater%20background%20with%20warm%20golden%20tones%2C%20artistic%20cinematography%20style%20with%20shallow%20depth%20of%20field%2C%20intimate%20storytelling%20atmosphere&width=640&height=360&seq=media-02&orientation=landscape',
    duration: '04:18',
  },
  {
    id: 3,
    title: '《极限追踪》高燃混剪',
    category: '动作冒险',
    views: '210.8万',
    image: 'https://readdy.ai/api/search-image?query=High-energy%20action%20movie%20montage%20with%20chase%20scenes%20and%20explosive%20visual%20effects%2C%20dark%20cinematic%20background%20with%20warm%20fire%20glow%2C%20dynamic%20film%20photography%20with%20motion%20and%20intensity%2C%20professional%20action%20cinema%20aesthetic&width=640&height=360&seq=media-03&orientation=landscape',
    duration: '03:42',
  },
  {
    id: 4,
    title: '《星辰之下》浪漫精选',
    category: '爱情文艺',
    views: '156.2万',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20film%20scene%20with%20starlit%20night%20sky%20and%20warm%20emotional%20atmosphere%2C%20dark%20cinematic%20background%20with%20soft%20glowing%20lights%2C%20beautiful%20cinematography%20with%20dreamy%20bokeh%20effects%2C%20tender%20love%20story%20visual%20aesthetic&width=640&height=360&seq=media-04&orientation=landscape',
    duration: '05:10',
  },
];

export const topics = [
  { id: 1, name: '#暑期档热播', count: '128.5万', trending: true },
  { id: 2, name: '#经典港片', count: '96.2万', trending: true },
  { id: 3, name: '#日韩剧场', count: '87.3万', trending: false },
  { id: 4, name: '#悬疑推理', count: '75.8万', trending: true },
  { id: 5, name: '#古装大戏', count: '68.1万', trending: false },
  { id: 6, name: '#高分电影', count: '112.4万', trending: true },
  { id: 7, name: '#都市情感', count: '59.6万', trending: false },
  { id: 8, name: '#动作大片', count: '82.7万', trending: true },
  { id: 9, name: '#动画动漫', count: '45.3万', trending: false },
];

export const cards = [
  {
    id: 1,
    title: '《暗夜追踪》——年度必看悬疑大作',
    description: '豆瓣8.7分高分悬疑片，层层反转烧脑不停，苹果视频与91视频网站同步上线高清完整版，悬疑爱好者不容错过的视频大片。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20noir%20scene%20with%20dark%20rainy%20street%20and%20detective%20silhouette%2C%20cinematic%20background%20with%20warm%20street%20lamp%20glow%2C%20suspenseful%20movie%20poster%20aesthetic%20with%20strong%20shadows%20and%20contrast%2C%20professional%20film%20noir%20photography&width=400&height=250&seq=card-01&orientation=landscape',
    tag: '悬疑',
    rating: 8.7,
  },
  {
    id: 2,
    title: '《花间辞》——古装唯美大制作',
    description: '豆花视频独家上线4K修复版，绝美服化道搭配动人剧情，古装剧年度口碑之作，高清影视画质呈现每一帧东方美学。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20costume%20drama%20scene%20with%20traditional%20garden%20and%20flowing%20silk%20fabrics%2C%20dark%20cinematic%20background%20with%20warm%20lantern%20light%2C%20artistic%20film%20photography%20with%20soft%20focus%20and%20rich%20colors%2C%20classical%20Chinese%20cinema%20aesthetic&width=400&height=250&seq=card-02&orientation=landscape',
    tag: '古装',
    rating: 9.1,
  },
  {
    id: 3,
    title: '《都市夜话》——现实题材口碑神作',
    description: '青青草视频热播都市剧，真实还原当代生活百态，引发全网热议。菠萝视频提供多线路高清视频播放支持，追剧无忧。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20scene%20with%20city%20nightscape%20and%20warm%20apartment%20interior%2C%20cinematic%20background%20with%20city%20lights%20bokeh%2C%20contemporary%20film%20photography%20with%20naturalistic%20lighting%2C%20realistic%20storytelling%20aesthetic&width=400&height=250&seq=card-03&orientation=landscape',
    tag: '都市',
    rating: 8.9,
  },
  {
    id: 4,
    title: '《极速风暴》——超燃赛车动作片',
    description: '肾上腺素飙升的顶级动作大片，红杏视频提供独家幕后花絮。高清影视震撼视听体验，飙车场景让人热血沸腾。',
    image: 'https://readdy.ai/api/search-image?query=High-octane%20racing%20action%20movie%20scene%20with%20sports%20cars%20and%20dramatic%20speed%20effects%2C%20dark%20cinematic%20background%20with%20warm%20explosive%20lighting%2C%20dynamic%20film%20photography%20with%20motion%20blur%2C%20intense%20action%20cinema%20aesthetic&width=400&height=250&seq=card-04&orientation=landscape',
    tag: '动作',
    rating: 8.5,
  },
  {
    id: 5,
    title: '《夏日的约定》——治愈系日剧精选',
    description: '苹果视频同步引进日本热门纯爱剧，温暖治愈直击人心。高清画质加上精美字幕，日剧爱好者的视频盛宴不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Heartwarming%20Japanese%20romance%20drama%20scene%20with%20summer%20countryside%20and%20soft%20sunlight%2C%20dark%20cinematic%20background%20with%20warm%20golden%20hour%20glow%2C%20gentle%20film%20photography%20with%20natural%20colors%2C%20healing%20storytelling%20atmosphere&width=400&height=250&seq=card-05&orientation=landscape',
    tag: '爱情',
    rating: 9.0,
  },
  {
    id: 6,
    title: '《深海谜踪》——科幻冒险新标杆',
    description: '91视频网站年度科幻巨制，深海探险题材视觉震撼。豆花视频和菠萝视频联合提供4K超清视频播放，每一帧都是壁纸级别。',
    image: 'https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20adventure%20film%20scene%20with%20deep%20ocean%20mysterious%20atmosphere%20and%20bioluminescent%20creatures%2C%20dark%20cinematic%20background%20with%20ethereal%20blue-green%20glow%2C%20epic%20film%20photography%20with%20vast%20scale%2C%20mysterious%20deep%20sea%20cinema%20aesthetic&width=400&height=250&seq=card-06&orientation=landscape',
    tag: '科幻',
    rating: 8.8,
  },
];

export const updates = [
  { id: 1, title: '《暗夜追踪》豆瓣开分8.7，悬疑片年度惊喜之作', time: '2小时前', tag: '新片' },
  { id: 2, title: '豆花视频上线4K修复版《花间辞》，古装美学再升级', time: '5小时前', tag: '画质' },
  { id: 3, title: '苹果视频与91视频网站联合推出暑期观影狂欢季', time: '1天前', tag: '活动' },
  { id: 4, title: '青青草视频新增日韩剧集专区，同步引进多部热剧', time: '1天前', tag: '上新' },
  { id: 5, title: '菠萝视频服务器全面升级，高清影视播放更流畅', time: '2天前', tag: '系统' },
  { id: 6, title: '红杏视频专题「港片黄金年代」上线，重温经典', time: '3天前', tag: '专题' },
  { id: 7, title: '《都市夜话》播放量突破2亿，全网热议不断', time: '3天前', tag: '热门' },
  { id: 8, title: '本站移动端体验优化完成，夜间模式全新上线', time: '4天前', tag: '功能' },
  { id: 9, title: '平台安全防护全面升级，保障用户视频观看隐私', time: '5天前', tag: '安全' },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '暗夜追踪', category: '悬疑', score: '9.7', change: 'up' },
  { id: 2, rank: 2, title: '花间辞', category: '古装', score: '9.5', change: 'up' },
  { id: 3, rank: 3, title: '都市夜话', category: '都市', score: '9.4', change: 'same' },
  { id: 4, rank: 4, title: '极速风暴', category: '动作', score: '9.2', change: 'down' },
  { id: 5, rank: 5, title: '夏日的约定', category: '爱情', score: '9.1', change: 'up' },
  { id: 6, rank: 6, title: '深海谜踪', category: '科幻', score: '8.9', change: 'up' },
  { id: 7, rank: 7, title: '时光之刃', category: '科幻', score: '8.8', change: 'new' },
];

export const indexItems = [
  {
    id: 1,
    title: '高分悬疑剧场',
    description: '精选豆瓣8分以上悬疑推理佳作，《暗夜追踪》《迷雾重重》《真相边缘》等高分影片一网打尽，红杏视频精心策划。',
    count: '56部',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20film%20collection%20with%20magnifying%20glass%20and%20clue%20boards%20in%20dark%20room%2C%20cinematic%20background%20with%20warm%20desk%20lamp%20lighting%2C%20investigation%20theme%20photography%20with%20film%20noir%20aesthetic%2C%20suspenseful%20atmosphere%20with%20rich%20shadows&width=400&height=220&seq=index-01&orientation=landscape',
  },
  {
    id: 2,
    title: '古装美学典藏',
    description: '汇集豆花视频和菠萝视频古装剧巅峰之作，《花间辞》《长安十二时辰》《琅琊榜》等经典，服化道精良视觉盛宴。',
    count: '42部',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20costume%20drama%20elegant%20arrangement%20with%20silk%20fabric%20and%20ancient%20accessories%2C%20dark%20cinematic%20background%20with%20warm%20lantern%20glow%2C%20classical%20Chinese%20film%20aesthetic%20photography%2C%20rich%20cultural%20texture%20and%20ornate%20details&width=400&height=220&seq=index-02&orientation=landscape',
  },
  {
    id: 3,
    title: '日韩热剧速递',
    description: '青青草视频独家引进最新日韩剧集，中文字幕同步更新，《夏日的约定》《樱花纷飞时》等热门剧集每周准时上线。',
    count: '38部',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20and%20Korean%20drama%20collage%20with%20cherry%20blossoms%20and%20modern%20city%20elements%2C%20dark%20cinematic%20background%20with%20soft%20pink%20and%20warm%20accents%2C%20Asian%20entertainment%20photography%20with%20clean%20elegant%20style%2C%20romantic%20storytelling%20atmosphere&width=400&height=220&seq=index-03&orientation=landscape',
  },
  {
    id: 4,
    title: '动作大片燃爆',
    description: '苹果视频和91视频网站联合推出动作片专场，《极速风暴》《铁拳无敌》《极限追踪》等燃爆肾上腺素的视觉盛宴。',
    count: '49部',
    image: 'https://readdy.ai/api/search-image?query=Explosive%20action%20movie%20montage%20with%20dynamic%20fight%20scenes%20and%20dramatic%20explosions%2C%20dark%20cinematic%20background%20with%20warm%20fire%20and%20spark%20effects%2C%20high-intensity%20film%20photography%20with%20energy%20and%20motion%2C%20blockbuster%20action%20cinema%20aesthetic&width=400&height=220&seq=index-04&orientation=landscape',
  },
  {
    id: 5,
    title: '纪录片精选库',
    description: '高清影视纪录片专区，涵盖自然、历史、科技、人文等多元题材，豆瓣评分8.5以上的精品纪录片一应俱全。',
    count: '63部',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20wildlife%20and%20vast%20landscapes%20in%20golden%20light%2C%20dark%20cinematic%20background%20with%20warm%20sunset%20tones%2C%20professional%20documentary%20photography%20with%20epic%20scale%2C%20educational%20and%20awe-inspiring%20atmosphere&width=400&height=220&seq=index-05&orientation=landscape',
  },
  {
    id: 6,
    title: '动画动漫盛宴',
    description: '豆花视频精选国内外优质动画，从国产精品到日本番剧，适合全年龄段观众，高清画质还原每一帧手绘之美。',
    count: '71部',
    image: 'https://readdy.ai/api/search-image?query=Anime%20and%20animation%20artistic%20collage%20with%20vibrant%20colors%20and%20dynamic%20character%20designs%2C%20dark%20cinematic%20background%20with%20colorful%20accent%20lights%2C%20Japanese%20anime%20style%20visual%20with%20creative%20energy%2C%20imaginative%20storytelling%20atmosphere&width=400&height=220&seq=index-06&orientation=landscape',
  },
  {
    id: 7,
    title: '经典老片修复',
    description: '菠萝视频和红杏视频联合推出经典影片4K修复计划，让老电影焕发新生，《港片黄金年代》系列持续更新中。',
    count: '34部',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20reels%20and%20old%20movie%20posters%20with%20nostalgic%20warm%20lighting%2C%20dark%20cinematic%20background%20with%20golden%20age%20Hollywood%20vibe%2C%20retro%20cinema%20photography%20with%20film%20grain%20texture%2C%20timeless%20movie%20heritage%20atmosphere&width=400&height=220&seq=index-07&orientation=landscape',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '榴莲视频是什么？有哪些视频资源？',
    answer: '榴莲视频是一个高清影视聚合平台，整合了苹果视频、91视频网站、豆花视频、菠萝视频、红杏视频、青青草视频等多家站点的优质内容，为用户提供一站式的视频播放和影视观看服务。我们每日更新海量内容，涵盖电影、电视剧、综艺、动漫等多种类型，所有资源均支持高清画质播放。',
  },
  {
    id: 2,
    question: '如何在不同设备上观看高清影视？',
    answer: '榴莲视频全面支持桌面端浏览器和移动端设备访问。您只需使用同一账号登录，即可在不同设备间无缝切换观看。我们采用了响应式设计技术，确保在手机、平板和电脑上都能获得优质的视频播放体验，自适应不同屏幕尺寸和分辨率。',
  },
  {
    id: 3,
    question: '视频播放卡顿怎么办？',
    answer: '如果遇到播放卡顿，建议您：1）检查网络连接是否稳定；2）尝试切换清晰度（从超清切换至高清或标清）；3）关闭其他占用带宽的应用；4）刷新页面重新加载。我们的服务器采用多节点部署，通常情况下菠萝视频和豆花视频线路都能提供流畅的高清影视观看体验。',
  },
  {
    id: 4,
    question: '平台内容多久更新一次？',
    answer: '榴莲视频与苹果视频、91视频网站等合作站点保持同步更新节奏。热门剧集通常在播出后数小时内即可上线，电影资源也会在首映后尽快更新。我们设有专门的更新运营团队，确保用户能够第一时间观看到最新的高清影视内容。',
  },
  {
    id: 5,
    question: '观看视频需要注册账号吗？',
    answer: '游客模式下即可直接浏览和观看大部分视频内容。注册账号后可以享受更多便利功能，包括观看历史同步、收藏夹管理、个性化内容推荐等。我们承诺不会收集用户隐私数据，保障每一位用户的视频观看安全。',
  },
  {
    id: 6,
    question: '平台的安全性如何？有隐私保障吗？',
    answer: '我们非常重视用户的数据安全和观看隐私。平台采用先进的加密传输技术，所有视频播放流量均经过安全加密处理。我们严格遵守隐私保护原则，不会向第三方泄露用户的观看记录和个人信息，让您可以放心畅享高清影视内容。',
  },
];